<script setup lang="ts">
const runtimeConfig = useRuntimeConfig();
const route = useRoute();
useHead({
  titleTemplate: "Koszty dostawy - %s",
  meta: [{ name: "robots", content: "index,follow" }],
  link: [
    { rel: "canonical", href: `${runtimeConfig.public.baseUrl}${route.path}` },
  ],
});
</script>

<template>
  <div class="container mx-auto p-4">
    <h1 class="text-24 md:text-32 font-bold mt-[30px]">Koszty dostawy</h1>
    <div class="overflow-x-auto mt-4">
      <table class="min-w-full bg-white border border-white">
        <thead>
          <tr>
            <th
              rowspan="2"
              class="px-6 py-3 border border-white text-center text-gray-600 bg-gray-300"
            >
              Forma dostawy
            </th>
            <th
              colspan="2"
              class="px-6 py-3 border border-white text-center text-gray-600 font-bold bg-gray-300"
            >
              Przedpłata
            </th>
            <th
              rowspan="2"
              class="px-6 py-3 border border-white text-center text-gray-600 bg-gray-300"
            >
              Pobranie
            </th>
          </tr>
          <tr>
            <th
              class="px-6 py-3 border border-white text-center text-gray-600 font-bold bg-gray-300"
            >
              Zamówienie o wartości poniżej 200 zł
            </th>
            <th
              class="px-6 py-3 border border-white text-center text-gray-600 font-bold bg-gray-300"
            >
              Zamówienie o wartości powyżej 200 zł
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-gray-50">
            <td class="px-6 py-4 border border-white text-center bg-gray-300">
              <b>Voucher elektroniczny</b> <br />(w minutę na Twoim mailu)<br />
            </td>
            <td class="px-6 py-4 border border-white text-center bg-gray-200">
              0 zł
            </td>
            <td class="px-6 py-4 border border-white text-center bg-gray-200">
              0 zł
            </td>
            <td class="px-6 py-4 border border-white text-center bg-gray-200">
              -
            </td>
          </tr>
          <tr>
            <td class="px-6 py-4 border border-white text-center bg-gray-300">
              <b>Kurier GLS</b> <br />(1-2 dni robocze)<br />
            </td>
            <td class="px-6 py-4 border border-white text-center">10 zł</td>
            <td class="px-6 py-4 border border-white text-center">5 zł</td>
            <td class="px-6 py-4 border border-white text-center">20 zł</td>
          </tr>
          <tr class="bg-gray-50">
            <td class="px-6 py-4 border border-white text-center bg-gray-300">
              <b>Paczkomaty InPost</b> <br />(1-2 dni robocze)<br />
            </td>
            <td class="px-6 py-4 border border-white text-center bg-gray-200">
              12,50 zł
            </td>
            <td class="px-6 py-4 border border-white text-center bg-gray-200">
              0 zł
            </td>
            <td class="px-6 py-4 border border-white text-center bg-gray-200">
              20 zł
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
